import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=1dadc762&scoped=true"
import script from "./TheFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./TheFooter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=1dadc762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dadc762",
  null
  
)

export default component.exports